module.exports = __webpack_public_path__ + "static/media/ico_discount1.e761b30e.png";